import { useMutation } from '@tanstack/react-query';

type Request = {
  candidateProfileId: number;
  interviewLogId: number;
};

export default function useDeleteCandidateInterviewLog() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, interviewLogId }: Request) => {
      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_interview_logs/${interviewLogId}`,
        {
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message || '削除に失敗しました');
      }

      return data;
    },
  });
}
